// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_ConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de GET /chamados/config e de POST /chamados/config/logo — o
 * estado atual do logo do e-mail de aviso.
 *
 * `logo_url` vazio é resposta válida: nenhum logo configurado pela tela ainda
 * (o e-mail cai no fallback do env ou no texto "New Shoes" — ver
 * `Chamados::corpoDoAviso()`), não um erro.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Chamados_ConfigResponseDados {
logo_url: string
}

export type Chamados_ConfigResponse = ApiResponse<Chamados_ConfigResponseDados>;

registerResponseContract('Chamados_ConfigResponse', {
  logo_url: { type: 'string',  required: true },
})
